The details of the uploaded `Candidate` to be deleted.
